import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	ResetButton,
	SubmitButton,
} from "@websential/cosmic-v20";

import { FC } from "react";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { Toolbar } from "@mui/material";

// import { EnhancedButtonPrimeReact } from "../../EnhancedButtonPrimeReact";
// import { EnhancedButtonPrimeReactSeverity } from "../../../common/Common";

export interface IPayrollQPIPEarningSetupToolbar {
	onResetClicked: () => void;
	onDeleteClicked: () => void;
	isSubmitting: boolean;
	id?: any;
}

export const PayrollQPIPEarningsSetupToolbar: FC<IPayrollQPIPEarningSetupToolbar> = ({
	onResetClicked,
	onDeleteClicked,
	isSubmitting = false,
	id,
}) => {
	return (
		<Toolbar>
			<>
				<EnhancedButtonPrimeReact
					label="Submit"
					loading={isSubmitting}
					type="submit"
					// icon="pi pi-check"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-plus"
					label="Reset"
					raised
					onClickHandler={onResetClicked}
					style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
				{/* <EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteClicked}
					style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
					disabled={!id ? true : false}
				/> */}
				{/* <DeleteButton testId="delete-button" onClickHandler={onDeleteClicked} /> */}
			</>
		</Toolbar>
	);
};
